module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"idcard_front":"头像面","idcard_front_tip":"上传您的身份证头像面","idcard_back":"国徽面","idcard_back_tip":"上传您的身份证国徽面","image_add_fail":"图片增加失败"},"en":{"idcard_front":"Front Side","idcard_front_tip":"Upload the front side of your ID card","idcard_back":"Back Side","idcard_back_tip":"Upload the back side of your ID card","image_add_fail":"Failed to add image"}}')
  delete Component.options._Ctor
}
